<template>
    <h1 class="text-h5 mb-4">
        <slot />
    </h1>
</template>
